import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/modules/dashboard/Dashboard.vue'
import Auth from '@/modules/auth/Auth.vue'
import Alarms from '@/modules/alarms/Alarms.vue'
import Cams from '@/modules/cams/Cams.vue'
import Map from '@/modules/map/Map.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/dashboard/views/main',
    },
    {
      path: '/auth',
      name: 'auth',
      component: Auth,
    },
    {
      path: '/dashboard/',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        auth: true,
      },
      props: { popup: 'agreement' },
      children: [
        {
          path: 'alarms/:alarmId?',
          name: 'alarms',
          component: Alarms,
          meta: {
            auth: true,
          },
        },
        {
          path: 'map/:mapGroupId/:mapId',
          name: 'map',
          component: Map,
          meta: {
            auth: true,
          },
        },
        {
          path: 'views',
          redirect: 'views/main'
        },
        {
          path: 'views/:viewId?/:mapGroupId?/:mapId?/:camId?',
          name: 'views',
          component: Cams,
          meta: {
            auth: true,
          },
        },
        {
          path: '',
          redirect: 'views/main',
        },
      ]
    },
  ],
  mode: 'history'
})





// WEBPACK FOOTER //
// ./src/common/router.js